<template>
  <div class="kortex-completion-config">
    <b-form-group
      :label="$t('kortex.agent')"
      label-for="kortex-agent-select"
    >
      <b-form-select
        id="kortex-agent-select"
        v-model="localData.agent_uuid"
        :options="agentOptions"
        :disabled="loadingAgents"
        @change="emitUpdate"
      >
        <template #first>
          <b-form-select-option :value="null" disabled>
            {{ loadingAgents ? $t('loading') : $t('kortex.selectAgent') }}
          </b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>

    <b-form-group
      :label="$t('kortex.systemInstructions')"
      label-for="kortex-system-prompt"
    >
      <b-form-textarea
        id="kortex-system-prompt"
        v-model="localData.system_prompt"
        :placeholder="$t('kortex.systemInstructionsPlaceholder')"
        rows="3"
        @input="emitUpdate"
      ></b-form-textarea>
      <small class="text-muted">{{ $t('kortex.systemInstructionsHint') }}</small>
    </b-form-group>

    <b-form-group
      :label="$t('kortex.userMessage')"
      label-for="kortex-content"
    >
      <b-form-textarea
        id="kortex-content"
        v-model="localData.content"
        :placeholder="$t('kortex.userMessagePlaceholder')"
        rows="2"
        @input="emitUpdate"
      ></b-form-textarea>
      <small class="text-muted">{{ $t('kortex.userMessageHint') }}</small>
    </b-form-group>

    <b-form-group
      :label="$t('kortex.responseFormat')"
      label-for="kortex-response-format"
    >
      <b-form-select
        id="kortex-response-format"
        v-model="localData.response_format"
        :options="responseFormatOptions"
        @change="emitUpdate"
      ></b-form-select>
      <small class="text-muted">{{ $t('kortex.responseFormatHint') }}</small>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'CompletionNodeConfig',
  props: {
    value: {
      type: Object,
      default: function () { return {} }
    }
  },
  data: function () {
    return {
      agents: [],
      loadingAgents: false,
      localData: {
        agent_uuid: null,
        system_prompt: '',
        content: '',
        response_format: 'text'
      }
    }
  },
  computed: {
    agentOptions: function () {
      var self = this
      return self.agents.map(function (agent) {
        return {
          value: agent.uuid,
          text: agent.name || agent.uuid
        }
      })
    },
    responseFormatOptions: function () {
      return [
        { value: 'text', text: this.$t('kortex.formatText') },
        { value: 'json', text: this.$t('kortex.formatJson') }
      ]
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (newVal) {
        if (!newVal) return
        if (newVal.agent_uuid !== undefined && newVal.agent_uuid !== this.localData.agent_uuid) {
          this.localData.agent_uuid = newVal.agent_uuid
        }
        if (newVal.system_prompt !== undefined && newVal.system_prompt !== this.localData.system_prompt) {
          this.localData.system_prompt = newVal.system_prompt
        }
        if (newVal.content !== undefined && newVal.content !== this.localData.content) {
          this.localData.content = newVal.content
        }
        if (newVal.response_format !== undefined && newVal.response_format !== this.localData.response_format) {
          this.localData.response_format = newVal.response_format
        }
      }
    }
  },
  mounted: function () {
    this.loadAgents()
    if (this.value) {
      if (this.value.agent_uuid !== undefined) this.localData.agent_uuid = this.value.agent_uuid
      if (this.value.system_prompt !== undefined) this.localData.system_prompt = this.value.system_prompt
      if (this.value.content !== undefined) this.localData.content = this.value.content
      if (this.value.response_format !== undefined) this.localData.response_format = this.value.response_format
    }
  },
  methods: {
    loadAgents: function () {
      var self = this
      self.loadingAgents = true
      self.$http.get('/luma/kortex/v1/agents', {
        params: { limit: 100, page: 1 }
      }).then(function (resp) {
        var data = resp.data
        self.agents = (data && data.data) || (Array.isArray(data) ? data : [])
      }).catch(function () {
        self.agents = []
      }).finally(function () {
        self.loadingAgents = false
      })
    },
    emitUpdate: function () {
      this.$emit('input', Object.assign({}, this.localData))
    }
  }
}
</script>

<style scoped>
.kortex-completion-config {
  padding: 4px 0;
}
</style>
